import { API_V2 } from "@/config/api";

const base = `${API_V2}/fundraising-campaigns`;

export const fundraisingCampaignRoutes = {
  list: base,
  get: (id: string) => `${base}/${id}`,
  create: base,
  update: (id: string) => `${base}/${id}`,
  delete: (id: string) => `${base}/${id}`,
  brandings: (id: string) => `${base}/${id}/brandings`,
  messaging: (id: string) => `${base}/${id}/messaging`,
  settings: (id: string) => `${base}/${id}/settings`,
  form: (id: string) => `${base}/${id}/form`,
  page: (id: string) => `${base}/${id}/page`,
  publishPage: (id: string) => `${base}/${id}/page/publish`,
  unpublishPage: (id: string) => `${base}/${id}/page/unpublish`,
  formFields: {
    list: (id: string) => `${base}/${id}/form-fields`,
    create: (id: string) => `${base}/${id}/form-fields`,
    reorder: (id: string) => `${base}/${id}/form-fields/reorder`,
    update: (id: string, fieldId: number) =>
      `${base}/${id}/form-fields/${fieldId}`,
    delete: (id: string, fieldId: number) =>
      `${base}/${id}/form-fields/${fieldId}`,
  },
};
